import { forwardRef, type ComponentProps } from 'react';

import { Item } from '@radix-ui/react-radio-group';

import { radioBaseStyle } from './RadioBase.css';
import { getClassNames } from '../../util/css';

export const sparkyRadioBaseClassName = 'sparky-radio-base';

type RadioBaseProps = ComponentProps<typeof Item>;

/**
 * An item that can be checked. An input will also render when used within a form to ensure events propagate
 * correctly. It doesn't contain focus or hover styles so you need to make sure those are added when you
 * use this component!
 */
export const RadioBase = forwardRef<HTMLButtonElement, RadioBaseProps>(({ className, ...props }, ref) => (
  <Item ref={ref} className={getClassNames(sparkyRadioBaseClassName, radioBaseStyle, className)} {...props} />
));

RadioBase.displayName = 'RadioBase';
